import React from 'react';
import BadgeDesigns from '../components/BadgeDesigns';
import SEO from '../components/SEO';

const BadgeDesignsPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Badge Designs | GoodCart"
        description="Explore our beautiful badge designs for GoodCart Perfect products and other quality certifications."
        url="https://goodcart.org/badge-designs"
        type="website"
      />
      
      <BadgeDesigns />
    </div>
  );
};

export default BadgeDesignsPage;